import { Configuration } from "./configuration";

export class ConfigurationService {
    public getConfiguration(): Promise<Configuration> {
        return fetch("configuration.json").then(data => data.json());
    }
}